// 输入组件视图类型

export enum InputUI {
  Default = 1, // 默认
  Typing,
  Photos,
  Emoji,
  Mention,
  Files,
  Voice
}
